import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { RichTextBlock } from '../rich-text.d'
import { useRichText } from '../rich-text.hook'

type Props = {
  content: RichTextBlock['children']
  className?: string
}

export const Paragraph = ({ content, className }: Props) => {
  const { renderChildren } = useRichText()

  return (
    <Typography
      className={className}
      color="textSecondary"
      component="p"
      variant="b2"
    >
      {renderChildren(content)}
    </Typography>
  )
}
